import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#f7f7f7",
    fontSize: 9,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#f7f7f7",
    minHeight: 25,
  },
  tableHeaderRow: {
    flexDirection: "row",
    backgroundColor: "#f8fbff",
    borderBottomWidth: 1,
    borderBottomColor: "#f7f7f7",
    minHeight: 30,
    color: "#777777",
  },
  tableCell: {
    flex: 1,
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#f7f7f7",
    justifyContent: "center",
    color: "#494949",
  },
  tableCellLast: {
    borderRightWidth: 0,
  },
  tableHeaderCell: {},
  tableCellText: {
    overflow: "hidden",
  },
  childRow: {
    // backgroundColor: "#f7f7f7",
  },
  sumRow: {
    borderBottomWidth: 0,
    borderTopColor: "#f7f7f7",
  },
});

export const TableRenderer = ({ columns, rows, sum, style }) => {
  const headerTable = columns.map(({ name }) => name);
  const columnCount = headerTable.length;

  return (
    <View style={[styles.table, style]}>
      {/* Header Row */}
      <View style={styles.tableHeaderRow} wrap={false}>
        {headerTable.map((header, index) => (
          <View
            key={index}
            style={[
              styles.tableCell,
              styles.tableHeaderCell,
              index === columnCount - 1 && styles.tableCellLast,
            ]}
          >
            <Text style={styles.tableCellText}>{header}</Text>
          </View>
        ))}
      </View>

      {/* Data Rows */}
      {rows.map((row, rowIndex) => (
        <View key={rowIndex}>
          <View style={styles.tableRow} wrap={false}>
            {Array.from({ length: columnCount }).map((_, cellIndex) => (
              <View
                key={cellIndex}
                style={[
                  styles.tableCell,
                  cellIndex === columnCount - 1 && styles.tableCellLast,
                ]}
              >
                <Text style={styles.tableCellText}>
                  {row.data?.[cellIndex] ?? ""}
                </Text>
              </View>
            ))}
          </View>

          {/* Child Rows */}
          {!!row.children?.length && (
            <>
              {row.children.map((childRow, childIndex) => (
                <View
                  key={childIndex}
                  style={[styles.tableRow, styles.childRow]}
                  wrap={false}
                >
                  {Array.from({ length: columnCount }).map((_, cellIndex) => (
                    <View
                      key={cellIndex}
                      style={[
                        styles.tableCell,
                        cellIndex === columnCount - 1 && styles.tableCellLast,
                      ]}
                    >
                      <Text style={styles.tableCellText}>
                        {childRow?.[cellIndex] ?? ""}
                      </Text>
                    </View>
                  ))}
                </View>
              ))}
            </>
          )}
        </View>
      ))}

      {/* Sum Row */}
      {!!sum?.filter(Boolean).length && (
        <View style={[styles.tableRow, styles.sumRow]} wrap={false}>
          {Array.from({ length: columnCount }).map((_, cellIndex) => (
            <View
              key={cellIndex}
              style={[
                styles.tableCell,
                cellIndex === columnCount - 1 && styles.tableCellLast,
              ]}
            >
              <Text style={styles.tableCellText}>
                {sum?.[cellIndex] ?? ""}
              </Text>
            </View>
          ))}
        </View>
      )}
    </View>
  );
};
